var map = {
	"./default.png": "fb36",
	"./doc.png": "31c4",
	"./excel.png": "d578",
	"./mp4.png": "2fc1",
	"./pdf.png": "c9cd",
	"./png.png": "4ac5",
	"./ppt.png": "6821",
	"./txt.png": "b3bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "335a";